export const SET_ALERT = '@ALR/SET_ALERT';
export const setAlert = data => ({
    type: SET_ALERT,
    data
});